import React, { useState, useEffect } from 'react';
import { InputGroup } from 'react-bootstrap';
import { useAuth } from '../../../../../Auth';
import { useAxios } from '../../../../../AxiosHandler';
import Select from 'react-select';

interface SelectMultiObject{
    SelectMulti: Function,
    TypeList: Array<string>
}

const typeList = ["User"];

function SelectMulti(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loadedOptions, setLoadedOptions] = useState([]);
    const [forceUpdate, setForceUpdate] = useState(0);
    
    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    const getOptions = () => {
        switch (props.options.typeLoad) {
            case "Manual": break;
            case "User":
                axios.all([
                    axios.single({
                        method: "get",
                        url: "/api/users",
                        responseType: "json",
                        headers: {'x-access-token': auth.user["token"]}
                    })
                ])
                .then(axios.spread((...res) => {
                    setLoadedOptions(res[0].data.map(user => { return {label: user["name"], value: user["_id"]} }));
                }));
                break;
        }
    }

    useEffect(() => {
        if (
            props.options != undefined &&
            props.options.typeLoad != undefined &&
            props.options.typeLoad != "Manual"
        ) {
            getOptions();
        }
    }, []);

    useEffect(() => {
        setForceUpdate(forceUpdate + 1);
    }, [props.options.choices, props.defaultValue]);

    return(
        <InputGroup className="mb-3">
            {props.title != undefined ?
                <InputGroup.Prepend>
                    <InputGroup.Text>{props.title}</InputGroup.Text>
                </InputGroup.Prepend>
            : null}
            <Select
                key={forceUpdate}
                components={props.options != undefined && props.options.customOption != undefined ? {
                    Option: props.options.customOption
                } : undefined}
                className="multiselect"
                closeMenuOnSelect={false}
                disabled={props.disabled}
                value={props.value}
                defaultValue={props.defaultValue}
                isMulti
                onChange={(vals) => handleChange(vals)}
                filterOption={props?.options?.filterOption ?? undefined}
                isOptionSelected={props?.options?.isOptionSelected ?? undefined}
                options={
                    [
                        ...(props.options != undefined && props.options.choices != undefined && props.options.choices.length > 0 ? props.options.choices : []),
                        ...(loadedOptions != undefined ? loadedOptions : []),
                    ]
                }
                noOptionsMessage={props.options.noresults}
                placeholder={props.options != undefined && props.options.choosetext != undefined ? props.options.choosetext : "Click to select values .."}
            />
        </InputGroup>
    );
}

export default {SelectMulti, TypeList: typeList} as SelectMultiObject;